import './bookings-nav.css'
import './static/chevron-left.svg'
